import * as React from 'react';
import {
    ShowButton,
    List,
    Datagrid,
    TextField,
    Filter,
    ReferenceField,
    ReferenceInput,
    SelectInput,
    BooleanField,
    DateField,
    Pagination,
} from 'react-admin';

//Doesnt quite work yet...
const JobFilter = props => (
    <Filter {...props}>
        <ReferenceInput
            label="Resource"
            source="resource_id"
            reference="resources"
            allowEmpty
        >
            <SelectInput optionText="name" />
        </ReferenceInput>
    </Filter>
);

const JobPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

const JobList = props => (
    <List {...props} 
        filters={<JobFilter />} 
        sort={{ field: 'start_time', order: 'DESC' }}
        perPage={25}
        pagination={<JobPagination />}>
        <Datagrid>
            <TextField source="id" />
            <ReferenceField label="Resource" source="schedule_id" reference="schedules">
                <ReferenceField label="Resource" source="resource_id" reference="resources">
                    <TextField source="name" />
                </ReferenceField>
            </ReferenceField>
            <DateField source="start_time" />
            <BooleanField source="is_running" />
            <BooleanField source="is_finished" />
            <TextField source="error" />
            <DateField source="started_time" />
            <DateField source="finished_time" />
            <ShowButton />
        </Datagrid>
    </List>
);

export default JobList;